<mat-card appearance="outlined">
  <mat-card-title class="tw-flex tw-justify-between">
    <span>{{ title }}</span>
    <span *ngIf="isDataEditable" class="link" (click)="manageCountries()">
      {{ 'containerComponents.countrySelection.manageCountries' | translate }}</span
    >
  </mat-card-title>

  <mat-chip-listbox *ngIf="countriesList?.length; else noCountriesTemplate">
    <mat-chip-option
      *ngFor="let country of countriesList"
      [selectable]="false"
      [removable]="true"
      (removed)="removeCountry(country)"
    >
      {{ country.name }}
      <ui-svg-icon [name]="iconNames.Close" [width]="18" matChipRemove></ui-svg-icon>
    </mat-chip-option>
  </mat-chip-listbox>
</mat-card>

<ng-template #noCountriesTemplate>
  <span *ngIf="isDataEditable">
    {{ 'common.field.please' | translate }}
    <span class="link" (click)="manageCountries()">{{
      'containerComponents.countrySelection.addCountries' | translate
    }}</span>
  </span>
</ng-template>
